module.exports = __webpack_public_path__ + "img/app-paofu.fa24becc.webp";